import { configureRequest } from "@asosteam/asos-web-request";
import noticeError from "src/app/utilities/noticeError";
import logger from "src/app/utilities/logger";

export default async function isOutOfHours({ storeCode }) {
  try {
    const request = configureRequest({
      logger,
      client: {
        name: "asos-contentweb-customer-care-help-pages",
        version: "1.0.0",
        platform: "CPT",
      },
    });

    const url = `/customer-care/out-of-hours?storeCode=${storeCode}`;
    const response = await request.get({
      url,
    });

    return response.data;
  } catch (error) {
    noticeError(error);

    return false;
  }
}
